<template>
  <div class="w-full h-full">
    <div class="flex justify-between items-center">
      <div class="title text-lg mb-10px cursor-pointer">
        <el-page-header
          v-if="pageType === 'read'"
          @back="$emit('cancel')"
          content="详情"
        ></el-page-header>
        <span
          v-if="pageType !== 'read'"
          class="border-l-3 border-color-primary pl-10px text-18px"
          >{{ pageType === 'create' ? '新增' : '编辑' }}</span
        >
      </div>
    </div>
    <div
      v-loading="pageLoading"
      class="w-full overflow-y-auto overflow-x-hidden"
      :class="[pageType === 'read' ? 'detail-height' : 'custom-height']"
    >
      <el-form ref="form" label-width="140px" :rules="rules" :model="formData">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="试卷基本信息" name="baseInfo">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item
                  label="试卷名称"
                  prop="paperName"
                  :rules="[
                    {
                      required: true,
                      message: `请输入试卷名称`,
                      trigger: ['change', 'blur'],
                    },
                  ]"
                >
                  <el-input
                    v-model="formData.paperName"
                    placeholder="请输入试卷名称"
                    maxlength="20"
                    show-word-limit
                    clearable
                    :disabled="['read'].includes(pageType)"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="试卷编码" prop="paperCode">
                  <el-input
                    v-model="formData.paperCode"
                    placeholder="请输入试卷编码"
                    maxlength="20"
                    show-word-limit
                    clearable
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item
                  label="试卷分类"
                  prop="paperCategory"
                  :rules="[
                    {
                      required: true,
                      message: `请选择试卷分类`,
                      trigger: ['change', 'blur'],
                    },
                  ]"
                >
                  <el-select
                    v-model="formData.paperCategory"
                    class="w-full"
                    size="small"
                    placeholder="请选择试卷分类"
                    :disabled="['read'].includes(pageType)"
                  >
                    <el-option
                      v-for="item in pagerTypeList"
                      :key="item.code"
                      :label="item.displayName"
                      :value="Number(item.code)"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="24"
                :md="12"
                :lg="12"
                :xl="8"
                :rules="[
                  {
                    required: true,
                    message: `请输入试卷总分`,
                    trigger: ['change', 'blur'],
                  },
                ]"
              >
                <el-form-item label="试卷总分" prop="totalScore">
                  <el-input-number
                    disabled
                    v-model="formData.totalScore"
                    placeholder="请输入试卷总分"
                    class="w-full"
                    :min="0"
                    :precision="0"
                    maxlength="10"
                    show-word-limit
                    clearable
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item
                  label="及格分数"
                  prop="passingscore"
                  :rules="[
                    {
                      required: true,
                      message: `请输入及格分数`,
                      trigger: ['change', 'blur'],
                    },
                  ]"
                >
                  <el-input-number
                    v-model="formData.passingscore"
                    placeholder="请输入及格分数"
                    class="w-full"
                    :min="0"
                    :precision="0"
                    maxlength="10"
                    show-word-limit
                    clearable
                    :disabled="['read'].includes(pageType)"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item
                  label="建议答题时长(min)"
                  prop="suggestedExamTime"
                  :rules="[
                    {
                      required: true,
                      message: `请输入建议答题时长`,
                      trigger: ['change', 'blur'],
                    },
                  ]"
                >
                  <el-input-number
                    v-model="formData.suggestedExamTime"
                    placeholder="请输入建议答题时长"
                    class="w-full"
                    :min="1"
                    :precision="0"
                    maxlength="10"
                    show-word-limit
                    clearable
                    :disabled="['read'].includes(pageType)"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item name="taskAssign" title="试题信息" class="relative">
            <el-dropdown class="absolute right-20px z-10" v-if="pageType === 'read'">
              <el-button size="small" type="primary">下载试卷</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="downloadPaper('downloadPaper')" class="text-center"
                  >空白卷</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="downloadPaper('downloadPaperWithAnswer')"
                  class="text-center"
                  >试卷（附答案）</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-tabs v-model="activeTab" @tab-click="tabClick">
              <template v-for="item in sourcesDangerRecognitionPlanTaskDtos">
                <el-tab-pane
                  :key="item.type"
                  v-if="pageType !== 'read' || item.children.length"
                  :label="item.name"
                  :name="`${item.type}`"
                >
                  <div class="mb-10px text-right">
                    <el-button type="primary" @click="deleteChildQuestion">一键移除</el-button>
                  </div>
                  <el-table
                    :data="questionList"
                    border
                    class="w-full mb-20px"
                    stripe
                    row-key="id"
                    default-expand-all
                    v-loading="tableLoading"
                    :tree-props="{ children: 'children' }"
                    v-if="showTable"
                  >
                    <el-table-column label="序号" type="index" width="50">
                      <template slot-scope="scope">
                        <span v-if="scope.row.level">{{
                          numToChinesUtils(scope.row.typeIndex)
                        }}</span>
                        <span v-else>{{ scope.row.parentIndex + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="题目名称" prop="name">
                      <template slot-scope="scope">
                        <span v-if="scope.row.level"
                          >{{ scope.row.name }}，共（{{
                            sourcesDangerRecognitionPlanTaskDtos[item.type].children.length
                          }}）题，共计（{{
                            questionScore(sourcesDangerRecognitionPlanTaskDtos[item.type].children)
                          }}）分</span
                        >
                        <content-view
                          v-else
                          :isShowIndex="false"
                          :row="scope.row"
                          :index="scope.row.parentIndex"
                          :pageConfig="{ MaxResultCount: 10, SkipCount: 0 }"
                        ></content-view>
                      </template>
                    </el-table-column>
                    <el-table-column label="题型" width="120" prop="type">
                      <template slot-scope="scope">
                        <span v-if="!scope.row.level">{{ typeListMap(scope.row.examType) }}</span>
                        <span v-else>题干</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="是否随机组题" width="120" prop="isRandom">
                      <template slot-scope="scope">
                        <div class="text-center">
                          <el-switch
                            v-model="scope.row.isRandom"
                            v-if="scope.row.level"
                            :disabled="['read'].includes(pageType)"
                          ></el-switch>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="分值" width="200" prop="score">
                      <template slot-scope="scope">
                        <span v-if="scope.row.level">{{
                          questionScore(sourcesDangerRecognitionPlanTaskDtos[item.type].children)
                        }}</span>
                        <el-input-number
                          v-else
                          v-model="scope.row.score"
                          placeholder="请输入建议答题时长"
                          class="w-full"
                          :min="1"
                          :precision="0"
                          maxlength="20"
                          show-word-limit
                          clearable
                          :disabled="['read'].includes(pageType)"
                        ></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="120">
                      <template slot-scope="scope">
                        <el-dropdown v-if="scope.row.level">
                          <el-button size="mini"
                            >关联题目<i class="el-icon-arrow-right el-icon--right"></i
                          ></el-button>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                              @click.native="
                                handleFormEvent(
                                  scope.row,
                                  scope.row.type,
                                  scope.row.parentIndex,
                                  'chooseRiskPoint'
                                )
                              "
                              :disabled="['read'].includes(pageType)"
                              >手动选择</el-dropdown-item
                            >
                            <el-dropdown-item
                              @click.native="openBatchAddDialog(scope.row)"
                              :disabled="['read'].includes(pageType)"
                              >批量选择</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <el-button
                        size="mini"
                        v-if="scope.row.level"
                        :disabled="['read'].includes(pageType)"
                        @click="
                          handleFormEvent(
                            scope.row,
                            scope.row.type,
                            scope.row.parentIndex,
                            'chooseRiskPoint'
                          )
                        "
                        >关联题目</el-button
                      >
                      <el-button
                        size="mini"
                        v-if="!scope.row.level"
                        :disabled="scope.row.parentIndex === 0 || ['read'].includes(pageType)"
                        @click="
                          handleFormEvent(
                            scope.row,
                            scope.row.examType,
                            scope.row.parentIndex,
                            'up'
                          )
                        "
                        >上移</el-button
                      >
                      <el-button
                        size="mini"
                        v-if="!scope.row.level"
                        :disabled="
                          scope.row.parentListLen - 1 === scope.row.parentIndex ||
                            ['read'].includes(pageType)
                        "
                        @click="
                          handleFormEvent(
                            scope.row,
                            scope.row.examType,
                            scope.row.parentIndex,
                            'down'
                          )
                        "
                        >下移</el-button
                      > -->
                        <el-button
                          :disabled="['read'].includes(pageType)"
                          size="mini"
                          v-if="!scope.row.level"
                          @click="
                            handleFormEvent(
                              scope.row,
                              scope.row.examType,
                              scope.row.parentIndex,
                              'delete'
                            )
                          "
                          >移除</el-button
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="text-right mb-20px">
                    <el-pagination
                      background
                      @size-change="sizeChange"
                      @current-change="setQuestionList"
                      :current-page.sync="page.pageNo"
                      layout="total, sizes, prev, pager, next, jumper"
                      :page-sizes="[15, 30, 45, 60, 75, 90]"
                      :page-size.sync="page.pageSize"
                      :total="sourcesDangerRecognitionPlanTaskDtos[activeTab].children.length"
                    ></el-pagination>
                  </div> </el-tab-pane
              ></template>
            </el-tabs>
            <el-button
              type="primary"
              class="absolute right-20px top-55px"
              @click="paperStrategyVisible = true"
              >选择策略</el-button
            >
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div
      class="w-full flex justify-center items-center !mt-20px !mb-20px"
      v-if="pageType !== 'read'"
    >
      <el-button
        type="primary"
        size="small"
        @click="submitForm('submit')"
        :loading="saveLoading"
        :disabled="pageLoading"
        >保存</el-button
      >
      <el-button @click="$emit('cancel')" size="small">取消</el-button>
    </div>

    <!-- 选择试题 -->
    <choose-topic-origin-form
      v-if="pointDialog"
      :taskIds="taskIds"
      pageOrigin="exam"
      :filterField="curExamType"
      :pointProps="pointProps"
      @add-type-question="addRiskPoint"
      @cancel="pointDialog = false"
    >
    </choose-topic-origin-form>
    <BatchAddTopic
      :visible.sync="batchAddTopicVisible"
      :type="topicType"
      :excludeIds="excludeTopicIds"
      @save="batchAddTopic"
    />
    <PaperStrategy
      v-if="paperStrategyVisible"
      :visible="paperStrategyVisible"
      @save="selectPaperStrategy"
      @close="closePaperStrategy"
    ></PaperStrategy>
  </div>
</template>

<script>
import { QuestionSourceApi, ExamPaperApi } from '@wiz-api/exam-management'
import { find, map, forEach } from 'lodash'
import utils from '@/components/safety/enumField/utils'
import { download } from '@/assets/js/CommonDownload'
import ChooseTopicOriginForm from '../ChooseTopicOriginForm'
import PaperStrategy from './PaperStrategy'
import BatchAddTopic from '../BatchAddTopic'
import ContentView from '../ContentView'
import { typeList } from '../EnumField'
import SecondService from '../../services/SecondService.js'

const questionSourceApi = new QuestionSourceApi()
const examPaperApi = new ExamPaperApi()
export default {
  name: 'paper-form',
  components: {
    ChooseTopicOriginForm,
    BatchAddTopic,
    ContentView,
    PaperStrategy,
  },
  props: {
    /**
     * @description: 上传传递的参数
     * @return {*}
     */
    pageType: {
      type: String,
      default: 'create',
    },
    rowId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      paperStrategyVisible: false,
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      batchAddTopicVisible: false,
      topicType: 0,
      ids: [],
      // 当前索引值
      curParentIndex: null,
      // 当前选择关联试题的类型, 默认单选题
      curExamType: 0,
      tableLoading: false,
      activeTab: '0',
      // 关联题源
      sourcesDangerRecognitionPlanTaskDtos: [
        {
          id: 1,
          typeIndex: 1,
          name: '单选题',
          type: 0,
          score: 0,
          level: 1,
          children: [],
          isRandom: false,
        },
        {
          id: 2,
          typeIndex: 2,
          name: '多选题',
          type: 1,
          score: 0,
          level: 1,
          children: [],
          isRandom: false,
        },
        {
          id: 3,
          typeIndex: 3,
          name: '判断题',
          type: 2,
          score: 0,
          level: 1,
          children: [],
          isRandom: false,
        },
        {
          id: 4,
          typeIndex: 4,
          name: '填空题',
          type: 3,
          score: 0,
          level: 1,
          children: [],
          isRandom: false,
        },
        {
          id: 5,
          typeIndex: 5,
          name: '简答题',
          type: 4,
          score: 0,
          level: 1,
          children: [],
          isRandom: false,
        },
      ],
      pageLoading: false,
      pagerTypeList: [],
      typeList,
      collapseActiveName: ['baseInfo', 'taskAssign'],
      selectionData: [],
      // 风险点
      pointProps: {
        visible: false,
      },
      pointDialog: false,
      saveLoading: false,
      formData: {
        paperName: '',
        paperCode: '',
        paperCategory: undefined,
        type: undefined,
        totalScore: 0,
        passingscore: 90,
        suggestedExamTime: 60,
        associateRiskyActivityType: undefined,
        singleChoiceQuantity: 0,
        multiSelectQuantity: 0,
        judgeQuantity: 0,
        fillBlankQuantity: 0,
        questionAnswersQuantity: 0,
        questionBankNotes: '',
        bankSourceIds: [],
      },
      rules: {},
      excludeTopicIds: [],
      questionList: [],
      showTable: true,
    }
  },
  computed: {
    // 序号转化
    numToChinesUtils() {
      return (val) => {
        return utils.numToChines(val)
      }
    },
    // 字段映射
    typeListMap() {
      return (val) => {
        return (
          this.typeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    // 类型分数
    questionScore() {
      return (val) => {
        return val.reduce((prev, item) => {
          return Number(prev) + Number(item.score)
        }, 0)
      }
    },
    // 禁用ids集合
    taskIds() {
      return this.ids
    },
    // 及格最大分数
    maxPassingscore() {
      return this.sourcesDangerRecognitionPlanTaskDtos.reduce((pre, item) => {
        const totalScore = item.children.reduce((preChild, itemChild) => {
          preChild = preChild + itemChild.score
          return preChild
        }, 0)
        pre = pre + totalScore
        return pre
      }, 0)
    },
  },
  watch: {
    // 计算总分
    sourcesDangerRecognitionPlanTaskDtos: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.totalScore = this.getTotalScore(newVal)
        }
        const ids = []
        forEach(this.sourcesDangerRecognitionPlanTaskDtos, (item) => {
          if (item.children && item.children.length > 0) {
            forEach(item.children, (ele) => {
              const id = ele.questionSourceId || ele.id
              ids.push(id)
            })
          }
        })
        this.ids = ids
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async selectPaperStrategy(strategyId) {
      this.pageLoading = true
      const [err, res] = await SecondService.getPaperQuestions({ id: strategyId })
      if (!err) {
        _.forEach(res, (item) => {
          const questions = _.map(item.questions, (el) => {
            return { ...el, score: item.score }
          })
          this.sourcesDangerRecognitionPlanTaskDtos[item.examType].children.push(...questions)
          this.sourcesDangerRecognitionPlanTaskDtos[item.examType].children = _.uniqBy(
            this.sourcesDangerRecognitionPlanTaskDtos[item.examType].children,
            (el) => {
              return el.questionSourceId || el.id
            }
          )
        })
        const notEnoughs = _.map(_.filter(res, ['isEnough', false]), (item) => {
          return this.sourcesDangerRecognitionPlanTaskDtos[item.examType].name
        })
        this.$message.warning(`【${notEnoughs.join('、')}】题量不足，请补充`)
        this.pageLoading = false
        this.addListIndex()
        this.setQuestionList()
      }
      this.paperStrategyVisible = false
    },
    closePaperStrategy() {
      this.paperStrategyVisible = false
    },
    deleteChildQuestion() {
      this.sourcesDangerRecognitionPlanTaskDtos[Number(this.activeTab)].children = []
      this.addListIndex()
      this.setQuestionList()
    },
    tabClick() {
      this.showTable = false
      this.page = this.$options.data().page
      this.setQuestionList()
      this.$nextTick(() => {
        this.showTable = true
      })
    },
    setQuestionList() {
      const list = [this.sourcesDangerRecognitionPlanTaskDtos[Number(this.activeTab)]]
      this.questionList = map(list, (item) => {
        return {
          ...item,
          children: item.children.slice(
            (this.page.pageNo - 1) * this.page.pageSize,
            (this.page.pageNo - 1) * this.page.pageSize + this.page.pageSize
          ),
        }
      })
    },
    sizeChange() {
      this.page.pageNo = 1
      this.setQuestionList()
    },
    async downloadPaper(type) {
      const [err, res] = await examPaperApi[type](this.formData.id)
      if (!err) {
        download(
          `${this.formData.paperName}${type === 'downloadPaperWithAnswer' ? '（附答案）' : ''}`,
          res,
          'application/pdf'
        )
      }
    },
    openBatchAddDialog(row) {
      this.topicType = row.type
      this.excludeTopicIds = map(
        this.sourcesDangerRecognitionPlanTaskDtos[row.type].children,
        (item) => {
          return item.questionSourceId || item.id
        }
      )
      this.batchAddTopicVisible = true
    },
    // 递归，算出总分
    getTotalScore(arr, totalScore = 0) {
      forEach(arr, (item) => {
        totalScore = totalScore + Number(item.score)
        if (item.children && item.children.length > 0) {
          forEach(item.children, (ele) => {
            totalScore = totalScore + Number(ele.score)
          })
        }
      })
      return totalScore
    },
    // 添加排序
    addListIndex() {
      let typeIndex = 1
      forEach(this.sourcesDangerRecognitionPlanTaskDtos, (item, index) => {
        this.$set(item, 'parentIndex', index)
        if (item.children && item.children.length > 0) {
          this.$set(item, 'typeIndex', typeIndex)
          typeIndex += 1
          forEach(item.children, (ele, eIndex) => {
            this.$set(ele, 'parentIndex', eIndex)
            this.$set(ele, 'parentListLen', item.children.length)
            if (!ele.score) {
              // 分数赋值
              this.$set(ele, 'score', 0)
            }
          })
        } else {
          this.$set(item, 'children', [])
        }
      })
    },
    // 获取题目详情
    async getTopicList() {
      const [err, res] = await examPaperApi.getExamPaperInfo({
        examPaperId: this.rowId,
      })
      if (!err) {
        return res
      }
      return []
    },
    // 获取详情
    async getDetail() {
      this.pageLoading = true
      const [err, res] = await examPaperApi.get(this.rowId)
      if (!err) {
        this.formData = { ...res }
        const sourcesDangerRecognitionPlanTaskDtos = JSON.parse(
          JSON.stringify(this.sourcesDangerRecognitionPlanTaskDtos)
        )
        const topicList = await this.getTopicList()
        forEach(res.examPaperSourceCorrelations, (item) => {
          const topic = find(topicList, { id: item.questionSourceId })
          if (topic) {
            item.topicContent = topic.topicContent
            item.correct = topic.correct
          }
          forEach(sourcesDangerRecognitionPlanTaskDtos, (i) => {
            if (i.type === item.examType) {
              i.children.push(item)
            }
          })
        })
        if (res.examTypeQuestionSortNoConfig) {
          const randomList = [
            'isSingleChoiceRandom',
            'isMultiSelectRandom',
            'isJudgeRandom',
            'isFillBlankRandom',
            'isQuestionAnswersRandom',
          ]
          forEach(randomList, (item, index) => {
            sourcesDangerRecognitionPlanTaskDtos[index].isRandom =
              res.examTypeQuestionSortNoConfig[item]
          })
        }
        this.sourcesDangerRecognitionPlanTaskDtos = sourcesDangerRecognitionPlanTaskDtos
        this.activeTab =
          `${
            find(this.sourcesDangerRecognitionPlanTaskDtos, (item) => {
              return item.children.length > 0
            })?.type
          }` || '0'
        // 添加orderIndex显示排序操作和进行排序
        this.addListIndex()
        this.tabClick()
        // if (!this.formData.bankSourceIds || this.formData.bankSourceIds.length === 0) {
        //   this.formData.bankSourceIds = []
        // } else {
        //   this.getChooseQestionList()
        // }
      }
      this.pageLoading = false
    },
    // 获取选中的题源内容
    async getChooseQestionList() {
      this.tableLoading = true
      const [err, res] = await questionSourceApi.pagedListQuery({
        skipCount: 0,
        maxResultCount: 999,
        bankSourceIds: this.formData.bankSourceIds,
      })
      if (!err) {
        this.sourcesDangerRecognitionPlanTaskDtos = res.items
      }
      this.tableLoading = false
    },
    // 添加风险测点
    addRiskPoint(data) {
      this.sourcesDangerRecognitionPlanTaskDtos[this.curParentIndex].children = [
        ...data,
        ...this.sourcesDangerRecognitionPlanTaskDtos[this.curParentIndex].children,
      ]
      this.addListIndex()
      this.setQuestionList()
      this.pointProps.visible = false
      this.pointDialog = false
    },
    batchAddTopic(data) {
      this.sourcesDangerRecognitionPlanTaskDtos[this.topicType].children.push(...data)
      this.addListIndex()
      this.setQuestionList()
    },
    /**
     * 列表操作-事件
     * @param {*} row 行数据
     * @param {*} examType 题目类型 单选，多选，判断，填空以及简答题, 默认单选题
     * @param {*} parentIndex 操作索引
     * @param {*} operation 操作类型
     */
    handleFormEvent(row, examType, parentIndex, operation) {
      let questionIndex = 0
      let childrenArr = []
      switch (operation) {
        // 删除
        case 'delete':
          this.$confirm('是否移除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              questionIndex = this.sourcesDangerRecognitionPlanTaskDtos.findIndex((item) => {
                return item.type === examType
              })
              childrenArr = this.sourcesDangerRecognitionPlanTaskDtos[questionIndex].children
              childrenArr.splice(parentIndex, 1)
              this.$nextTick(() => {
                this.addListIndex()
                this.setQuestionList()
              })
            })
            .catch(() => {})
          break
        // 选择关联试题
        case 'chooseRiskPoint':
          this.curParentIndex = parentIndex
          this.curExamType = examType
          this.pointProps.visible = true
          this.pointDialog = true
          break
        case 'up':
          questionIndex = this.sourcesDangerRecognitionPlanTaskDtos.findIndex((item) => {
            return item.type === examType
          })
          childrenArr = this.sourcesDangerRecognitionPlanTaskDtos[questionIndex].children
          childrenArr.splice(
            parentIndex - 1,
            1,
            ...childrenArr.splice(parentIndex, 1, childrenArr[parentIndex - 1])
          )
          this.addListIndex()
          break
        case 'down':
          questionIndex = this.sourcesDangerRecognitionPlanTaskDtos.findIndex((item) => {
            return item.type === examType
          })
          childrenArr = this.sourcesDangerRecognitionPlanTaskDtos[questionIndex].children
          childrenArr.splice(
            parentIndex,
            1,
            ...childrenArr.splice(parentIndex + 1, 1, childrenArr[parentIndex])
          )
          this.addListIndex()
          break
        default:
          break
      }
    },
    /**
     * 表单提交
     */
    async submitForm() {
      let err = null
      let res = null
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.formData.passingscore > this.formData.totalScore) {
            this.$message.warning('及格分数不能大于试卷总分')
            return
          }
          const sourcesDangerRecognitionPlanTaskDtos = JSON.parse(
            JSON.stringify(this.sourcesDangerRecognitionPlanTaskDtos)
          )
          // 处理逻辑
          const bankSourceIds = _.map(sourcesDangerRecognitionPlanTaskDtos, (item) => {
            return item.id
          })
          this.$set(this.formData, 'bankSourceIds', bankSourceIds)
          // 题目个数
          this.formData.singleChoiceQuantity = _.filter(
            sourcesDangerRecognitionPlanTaskDtos,
            (item) => {
              return item.examType === 0
            }
          ).length
          this.formData.multiSelectQuantity = _.filter(
            sourcesDangerRecognitionPlanTaskDtos,
            (item) => {
              return item.examType === 1
            }
          ).length
          this.formData.judgeQuantity = _.filter(sourcesDangerRecognitionPlanTaskDtos, (item) => {
            return item.examType === 2
          }).length
          this.formData.fillBlankQuantity = _.filter(
            sourcesDangerRecognitionPlanTaskDtos,
            (item) => {
              return item.examType === 3
            }
          ).length
          this.formData.questionAnswersQuantity = _.filter(
            sourcesDangerRecognitionPlanTaskDtos,
            (item) => {
              return item.examType === 4
            }
          ).length
          const examPaperSourceCorrelations = sourcesDangerRecognitionPlanTaskDtos.reduce(
            (pre, item) => {
              if (item.children && item.children.length) {
                pre = [...pre, ...item.children]
              }
              return pre
            },
            []
          )
          if (examPaperSourceCorrelations.length === 0) {
            this.$message({
              showClose: true,
              message: '请选择关联试题',
              type: 'warning',
            })
            return
          }
          this.formData.examPaperSourceCorrelations = examPaperSourceCorrelations.map(
            (item, index) => {
              const i = {
                topic: item.topic,
                examType: item.examType,
                score: item.score,
                ordination: index + 1,
                questionSourceId: item.questionSourceId ? item.questionSourceId : item.id,
              }
              if (this.formData.id) {
                i.id = item.questionSourceId ? item.id : '00000000-0000-0000-0000-000000000000'
              }
              return i
            }
          )
          const examTypeQuestionSortNoConfig = {}
          const randomList = [
            'isSingleChoiceRandom',
            'isMultiSelectRandom',
            'isJudgeRandom',
            'isFillBlankRandom',
            'isQuestionAnswersRandom',
          ]
          forEach(randomList, (item, index) => {
            examTypeQuestionSortNoConfig[item] =
              this.sourcesDangerRecognitionPlanTaskDtos[index].isRandom
          })
          this.formData.examTypeQuestionSortNoConfig = examTypeQuestionSortNoConfig
          this.saveLoading = true
          if (this.formData.id) {
            // 编辑
            ;[err, res] = await examPaperApi.update(this.formData.id, {
              body: this.formData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
          } else {
            // 新增

            ;[err, res] = await examPaperApi.create({
              body: this.formData,
            })
            if (!err) {
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
              this.$emit('refreshList')
            }
          }
          this.saveLoading = false
        }
      })
    },
  },
  async mounted() {
    utils.getDataCategory(
      ['ExamManagement.DataCategory.ExamPapersClassification'],
      ['pagerTypeList'],
      this
    )
    if (this.pageType !== 'create') {
      await this.getDetail()
    } else {
      this.addListIndex()
      this.setQuestionList()
    }
  },
}
</script>

<style scoped lang="scss">
.form-nolabel {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
    margin-top: 20px !important;
  }
}

.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
</style>
